/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { HyperlinkModel } from './hyperlinkModel';


/**
 * Model representing string content with placeholders defined by {0}, {1}, {2}, etc to be substitued by the list of Hyperlinks
 */
export class StringWithHyperlinkParametersModel { 
    /**
     * String content with optional placeholders defined by {0}, {1}, {2}, etc. to be substitued by the array of Hyperlinks by their position [0], [1], [2], etc.
     */
    StringContent?: string;
    /**
     * List of hyperlinks to be inserted into the StringContent placeholders by position in the array: [0] to {0}, [1] to {1}, [2] to {2}, etc.
     */
    Hyperlinks?: Array<HyperlinkModel>;
}



// WEBPACK FOOTER //
// ./src/app/model/stringWithHyperlinkParametersModel.ts